import BaseComponent from "./base-component";

export function BaseLayoutFactory({ children, fullWidth = false }: { children: React.ReactNode, fullWidth?: boolean }) {

    return (
        <BaseComponent fullWidth={fullWidth}>
            {children}
        </BaseComponent>
    );
}
